import React, { useEffect, useState } from "react";
import { Eye, EyeOff } from 'lucide-react';
import { Helmet } from "react-helmet";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import Header from "../../Utilities/Header";
import Footer from "../../Utilities/Footer";
import "./login.css";
import CryptoJS from "crypto-js";
import ForgetPasswordModal from "./ForgetPasswordModal";

// Encryption logic
const CryptoJSAesJsons = {
  stringify: (cipherParams) => {
    return JSON.stringify({
      ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64),
      iv: cipherParams.iv.toString(CryptoJS.enc.Hex),
      s: cipherParams.salt.toString(CryptoJS.enc.Hex),
    });
  },
  parse: (jsonStr) => {
    const j = JSON.parse(jsonStr);
    return CryptoJS.lib.CipherParams.create({
      ciphertext: CryptoJS.enc.Base64.parse(j.ct),
      iv: CryptoJS.enc.Hex.parse(j.iv),
      salt: CryptoJS.enc.Hex.parse(j.s),
    });
  },
};

const encryptPassword = (password) => {
  const key = "W@ealth!@$#$(%#H(^%)";
  return CryptoJS.AES.encrypt(JSON.stringify(password), key, {
    format: CryptoJSAesJsons,
  }).toString();
};

const BranchLogin = () => {
  const router = useNavigate();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showForgotModal, setShowForgotModal] = useState(false); // ✅ Modal toggle

  const [provider, setProvider] = useState({
    username: "",
    password: "",
    loginFor: "BRANCH",
    callbackUrl: "https://www.wisefinserv.com/branch-login",
    siteUrl: "https://portfolio.wisefinserv.com/"
  });

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await axios.post("https://redvisionweb.com/api/login/arn-login", provider);
      if (res?.data?.status === true) {
        window.location.href = res.data.url;
      } else {
        setError(res.data.msg);
      }
    } catch (err) {
      setError("Please fill the login details");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      <Helmet>

        <meta charSet="utf-8" />

        <title>Login | WiseFinserv</title>

        <link rel="canonical" href="https://www.wisefinserv.com/login" />

        <meta name="description" content="Login securely to access your financial portfolio." />

        <meta name="keywords" content="Client login, secure access, financial portfolio" />

      </Helmet>

      <Header />
      <div className="login">
        <section className="client-login">
          <div className="container">
            <div className="row">
              <div className="col-sm-1" />
              <div className="col-sm-10">
                <div className="" id="signinForm">
                  <div className="signinForm-body">
                    <img src="https://res.cloudinary.com/ddwk3hbiu/image/upload/v1699738163/Wise%20FinServ%20Private%20Wealth/Client%20login/bg_okucvk.jpg" alt="" />
                    <div className="form-body">
                      <h3 className="animation">Branch Login</h3>
                      <form onSubmit={handleSubmit}>
                        <div className="input-box animation">
                          <label>Username</label>
                          <input
                            type="text"
                            value={provider.username}
                            onChange={(e) =>
                              setProvider({ ...provider, username: e.target.value })
                            }
                            placeholder="Enter your User Name"
                            required
                          />
                          <br />
                          <div className="password">
                            <label>Password</label>
                            <input
                              type={showPassword ? "text" : "password"}
                              placeholder="******"
                              required
                              value={provider.password}
                              onChange={(e) =>
                                setProvider({ ...provider, password: e.target.value })
                              }
                            />
                            <span
                              onClick={() => setShowPassword((prev) => !prev)}
                              className="pass-eye"
                            >
                              {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                            </span>
                          </div>
                        </div>

                        <p className="forgot-password">
                          <a
                            type="button"
                            onClick={() => setShowForgotModal(true)}
                            className="text-blue-600 underline border-0 bg-transparent"
                          >
                            Forgot Password?
                          </a>
                        </p>

                        <div>
                          <button className="login-btn" type="submit">
                            {loading ? "Please wait..." : "Login"}
                          </button>
                        </div>
                        <p className="error text-center">{error}</p>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* ✅ Render Modal */}
      <ForgetPasswordModal
        isOpen={showForgotModal}
        onClose={() => setShowForgotModal(false)}
      />

      <Footer />
    </>
  );
};

export default BranchLogin;
